import { DespatchTask } from "Models/despatch.task";
import { getUserTimeFormatPattern, UserPreferences } from "Util/dateFormaterPreference";

export const isSameDate = (from: string, to: string) => {
  const fromDate = new Date(from);
  const toDate = new Date(to);

  const isEqualDate = fromDate.getDate() === toDate.getDate();
  const isEqualMonth = fromDate.getMonth() === toDate.getMonth();
  const isEqualYear = fromDate.getFullYear() === toDate.getFullYear();

  return isEqualDate && isEqualMonth && isEqualYear;
};

export function hasTaskTimezoneIssues(
  formatWithUserTimezone: (date: string, format: string) => string,
  task?: DespatchTask,
  preferences?: UserPreferences
): boolean {
  if (!task || !task.startDate || !task.endDate) return false;

  let datesAreTheSame = true;

  if (task?.endDate) {
    datesAreTheSame = isSameDate(task.startDate, task.endDate);
  }

  if (!datesAreTheSame) return false;

  if (preferences?.timeFormat !== "12_HOUR") return false;

  const timePattern = getUserTimeFormatPattern(preferences);
  const endDateFormatted = formatWithUserTimezone(task?.endDate, timePattern);
  const startDateFormatted = formatWithUserTimezone(task?.startDate, timePattern);

  return (
    datesAreTheSame &&
    endDateFormatted.toLowerCase().includes("am") &&
    startDateFormatted.toLowerCase().includes("pm")
  );
}
